import {Pipe, PipeTransform} from '@angular/core';
import {Team} from "../../domain/models";
import Fuse from 'fuse.js';

@Pipe({
  name: 'filterTeams'
})
export class FilterTeamsByBibPipe implements PipeTransform {
  private fuse = new Fuse([], {
    keys: ['cleanName'],
    threshold: 0.2,
    isCaseSensitive: false,
    includeScore: true,
    shouldSort: true,
  });

  transform(items: Team[], searchText: string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    var searchQuery = searchText.replace(/[-\s]/g, '') // Удаляем дефисы и пробелы [[3]]
      .trim()

    const processedItems = items.map(item => ({
      ...item,
      cleanName: item?.name
        ?.replace(/[-\s]/g, '') // Удаляем дефисы и пробелы [[3]]
        ?.trim()
    }));
    this.fuse.setCollection(processedItems)
    var res = this.fuse.search(searchQuery).map(result => result.item)
    return res
  }
}
